import { createBrowserRouter } from "react-router";
import AppShell, { homeLoader } from "@/layouts/AppShell";
import { HomeErrorBoundary } from "@/routes/home/Home";
import PageError from "@/routes/PageError";
import { ROUTES } from "@/constants/routes";
import { homeRoutes } from "./routes/home.routes";
import { accountRoutes } from "./routes/account.routes";
import { idkortRoutes } from "./routes/idkort.routes";
import { efteruddannelseRoutes } from "./routes/efteruddannelse.routes";
import { klientkontoRoutes } from "./routes/klientkonto.routes";
import { sluterklaeringRoutes } from "./routes/sluterklaering.routes";
import { tilsynRoutes } from "./routes/tilsyn.routes";
import { selskabsblankettenRoutes } from "./routes/selskabsblanketten.routes";
import { designRoutes } from "./routes/design.routes";
import { authCallbackRoutes } from "./routes/authCallback.routes";
import { publicRoutes } from "./routes/public.routes";

export const router = createBrowserRouter([
  {
    path: "/",
    id: ROUTES.homeIndex.id,
    element: <AppShell />,
    errorElement: <HomeErrorBoundary />,
    loader: homeLoader,
    children: [
      ...homeRoutes,
      ...efteruddannelseRoutes,
      ...klientkontoRoutes,
      ...sluterklaeringRoutes,
      ...tilsynRoutes,
      ...selskabsblankettenRoutes,
      ...designRoutes,
      ...accountRoutes,
      ...idkortRoutes,
      ...authCallbackRoutes,
      {
        path: "*",
        id: ROUTES.notFoundHome.id,
        element: <PageError />,
      },
    ],
  },
  ...publicRoutes,
]);
